module.exports = __webpack_public_path__ + "img/sodelco-logo-3x.e59f7355.png";